/*
 * @Author: Dong
 * @Date: 2022-04-06 09:33:32
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-14 16:19:29
 */
import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import AppLayout from 'root/layouts';
import { MessageDescriptor } from 'react-intl';
import { lazyLoad } from './utils';
import messages from './messages';

export interface RoutesType extends RouteObject {
  title?: string | MessageDescriptor;
  icon?: string;
  children?: RoutesType[];
  disabled?: boolean;
}

const EnvManage = lazy(() => import('root/pages/EnvManage'));
const PackageManage = lazy(() => import('root/pages/PackageManage'));

// 向导
// const Guide = lazy(() => import('root/pages/Guide'));
// 安装supOS
const InstallSupos = lazy(() => import('root/pages/InstallSupos'));
// 登录页
const Login = lazy(() => import('root/pages/User/Login'));
// 磁盘分区页面
const DiskConfig = lazy(() => import('root/pages/DiskConfig'));
// 纳管
const InductiveManage = lazy(() => import('root/pages/InductiveManage'));
// 服务的实时日志
const ServiceLog = lazy(() => import('root/components/MonitorManage/RealTimeLog/ServiceLog'));
// 多实例管理
const MultipleInstances = lazy(() => import('root/pages/MultipleInstances'));

// 路由数据
const menuRoutes: RoutesType[] = [
  {
    path: '/',
    element: <AppLayout />,
    children: [
      // {
      //   path: 'sysMonitor',
      //   title: messages.sysMonitor,
      //   icon: 'nav_supervise20',
      //   element: lazyLoad(<PlatformManage />),
      // },
      {
        path: 'envManage',
        title: messages.envManage,
        icon: 'nav_environment20',
        element: lazyLoad(<MultipleInstances />),
      },
      {
        path: 'packageManage',
        title: messages.packageManage,
        icon: 'nav_package20',
        element: lazyLoad(<PackageManage />),
      },
      {
        path: '/instances',
        element: lazyLoad(<EnvManage />),
      },
      // {
      //   path: 'syncBack',
      //   title: messages.syncBack,
      //   icon: 'nav_backuprestore',
      //   element: lazyLoad(<SyncBack />),
      // },
      // {
      //   path: 'diskPartition',
      //   title: messages.diskPartition,
      //   icon: 'nav_server20',
      //   element: lazyLoad(<DiskPartition />),
      // },
      // {
      //   path: 'installer',
      //   title: messages.installer,
      //   icon: 'nav_installdone20',
      //   element: lazyLoad(<PlatformManage />),
      // },
    ],
  },
  {
    path: '/login',
    element: lazyLoad(<Login />),
  },
  {
    path: '*',
    element: <div>404</div>,
  },
  {
    path: '/serviceLog/:key',
    element: lazyLoad(<ServiceLog />),
  },
];

const routes = [...menuRoutes];

routes[0].children = [
  ...(routes[0].children || []),
  {
    path: 'guide',
    element: lazyLoad(<DiskConfig />),
  },
  {
    path: 'inductive',
    element: lazyLoad(<InductiveManage />),
  },
  {
    path: 'supos',
    element: lazyLoad(<InstallSupos />),
  },
];

export { menuRoutes, routes };
